import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


export default function SnackBar({open,title}) {


    return (
        <div>
        <Snackbar
            open={open}
            autoHideDuration={6000}
        >
            <Alert variant="filled" severity="success" style={{width:"300px",fontSize:'20px',display:'flex',alignItems:'center',gap:'5px'}}>
            {title}
            </Alert>
        </Snackbar>
        </div>
    );
}